import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { PageDefault } from '../PageDefault'; 
import { NewsService } from './../../services/news.service';


@Component({
    selector: 'account-search',
    templateUrl: 'accountsearch.html' ,
    providers: [
        NewsService,
    ]
})
export class AccountSearch {
    start = PageDefault.endNowDate();
    end = PageDefault.endDate();
    PageIndex=1;
    subUserName = "";
    type = "0";
    subUserNames=[];
    tracks = {};
    constructor(private viewCtrl: ViewController, private navpar: NavParams,private newsService: NewsService,) {
        this.start = navpar.data.startDate != undefined ? navpar.data.startDate : PageDefault.endNowDate();
        this.end = navpar.data.endDate != undefined ? navpar.data.endDate : PageDefault.endDate();
        // this.type = navpar.data.type != undefined ? navpar.data.type : "0";
        this.subUserName = navpar.data.subUserName != undefined ? navpar.data.subUserName : "";
        this.PageIndex=1;
        if( navpar.data.type=='1' && navpar.data.type){
            this.type='1';
            this.getSubUserNames();
        }else{
            this.type='0';
        }
    }


    //查询条件
    //TQQ 2017-01-03
    applyFilters() {
        this.tracks["startDate"] = this.start;
        this.tracks["endDate"] = this.end;
        this.tracks["subUserName"] = this.subUserName;
        this.tracks["PageIndex"]=1;
        this.tracks["type"]=this.type;
        this.dismiss(this.tracks);
    }
    //获取当前用户的下级列表
    //TQQ 2017-06-15
    getSubUserNames() {
        this.newsService.getSubUserNames().then(data => {
            if (!data || data.length < 1) {
                return;
            }
            this.subUserNames=[{ label: "请选择", value: "" }];
            data.forEach(u => {
                this.subUserNames.push({ label: u, value: u });
            });
            this.subUserName=this.subUserName?this.subUserName:this.subUserNames[0].value;
            // this.subUserName=this.subUserNames[0].value;
        });
    }     
    //判断是个人或团队
    perTeam(){
        if(this.type=='1'){
            this.getSubUserNames();
        }
    }
    //关闭
    //TQQ 2017-01-03
    dismiss(data?: any) {
        this.viewCtrl.dismiss(data);
    }



}


// WEBPACK FOOTER //
// ./src/pages/accountchange/accountsearch.ts